import React, { useState } from 'react';
import * as S from './styles';
import {
  CaretUp,
  HexagonMinus,
  OpenIcon,
  Star,
  StarRating,
} from 'components/Icons';
import { InvoiceStatus } from 'components/InvoiceStatus';
import { theme } from 'styles/theme';
import CaretDoubleUpWhite from 'components/Icons/CaretDoubleUpWhite';
import Toast from 'components/Toast/Toast';

interface ICard {
  name: string | undefined;
  status: 'baixo' | 'medio' | 'alto' | 'médio' | 'novo cliente';
  operation: 'sale' | 'rent';
  broker?: string;
  href?: string;
  potentialOrigin?: 'lais' | 'kenlo';
}
const getTextQuality = (el: string | null) => {
  switch (el) {
    case 'alto':
      return 'Lead quente';
    case 'medio':
    case 'médio':
      return 'Lead morno';
    case 'baixo':
      return 'Lead frio';
    case 'new':
      return 'Novo lead';
    case null:
      return 'Novo lead';
    case 'novo cliente':
      return 'Novo lead';
    default:
      break;
  }
};
const getIconQuality = (el: string, origin: 'lais' | 'kenlo' | undefined) => {
  if (origin === 'lais' && el !== null)
    return <StarRating type={el === 'alto' ? 'filled' : 'outline'} />;

  switch (el) {
    case 'alto':
      return <CaretDoubleUpWhite width="18" height="18" />;
    case 'medio':
    case 'médio':
      return <CaretUp width="16" height="16" />;
    case 'baixo':
      return <HexagonMinus width="20" height="20" />;
    case null:
      return <Star />;
    case 'novo cliente':
      return <Star />;
    default:
      break;
  }
};
const operationStatus = {
  sale: 'Venda',
  rent: 'Locação',
  venda: 'Venda',
  locacao: 'Locação',
  'novo cliente': 'Dupla pretensão',
};
type ToastEntity = {
  message: string;
  type: 'success' | 'error' | 'warning';
};

const CardDrawer = ({
  name,
  status,
  operation,
  broker,
  href,
  potentialOrigin,
}: ICard) => {
  const [isMobile, setIsMobile] = React.useState(false);
  const [toast, setToast] = useState(false);
  const [dataForToast, setDataForToast] = useState<ToastEntity | undefined>(
    undefined,
  );

  React.useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 800);
    };

    // Verificar no carregamento
    checkMobile();

    // Adicionar event listener para mudanças de largura
    window.addEventListener('resize', checkMobile);

    // Limpar event listener
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  const type = operationStatus[operation] || null;
  const openToast = () => {
    setDataForToast({
      type: 'error',
      message:
        'Tivemos um problema para encontrar o atendimento, faça a busca diretamente no Imob.',
    });
    setToast(true);
  };

  return (
    <S.CardContent>
      <div>
        <S.TextAside fontSize="16" fontWeight="700">
          {name || `Não informado`}
        </S.TextAside>
        <S.TextCard fontSize="12" color="#808080">
          {type}
          <S.TextCard fontSize="20" color="#808080" fontWeight="700">
            &nbsp;&#183;&nbsp;
          </S.TextCard>
          {broker ? (
            broker
          ) : (
            <S.TextCard fontSize="12" color="#DD442C">
              Sem corretor no atendimento
            </S.TextCard>
          )}
        </S.TextCard>
      </div>
      <div style={{ display: 'flex', gap: '16px' }}>
        <InvoiceStatus
          status={
            potentialOrigin === 'lais'
              ? `lais-${status}`
              : (status === 'baixo' && 'venda') ||
                (status === 'médio' && 'average') ||
                (status === null && 'average') ||
                (status === 'novo cliente' && 'average') ||
                (status === 'alto' && status)
          }
          text={getTextQuality(status)}
          icon={getIconQuality(status, potentialOrigin)}
          colortText={
            status === 'alto'
              ? theme.colors.neutral.neutral0
              : theme.colors.neutral.neutral120
          }
          fontWeight="500"
        />
        {!isMobile ? (
          href ? (
            <a
              href={href}
              style={{ alignSelf: 'center', cursor: 'pointer' }}
              target="_blank"
              rel="noreferrer"
            >
              <OpenIcon />
            </a>
          ) : (
            <span
              onClick={openToast}
              style={{ alignSelf: 'center', cursor: 'pointer' }}
            >
              <OpenIcon />
            </span>
          )
        ) : null}
      </div>
      {toast && (
        <Toast
          type={dataForToast?.type || 'warning'}
          message={dataForToast?.message || ''}
          onClose={() => setToast(false)}
        />
      )}
    </S.CardContent>
  );
};

export default CardDrawer;
